import React from 'react'
import DataLoader from '../data/DataLoader'
import {connect} from 'react-redux'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

class Testimonials extends React.Component {


  constructor(){

    super();

    this.state={
      rows : [],
      currentScreenIndex : 0,
      autoPlay: ''
    }

    this.nextScreen = this.nextScreen.bind(this);
    this.prevScreen = this.prevScreen.bind(this);

    this.clickNextScreen = this.clickNextScreen.bind(this);
    this.clickPrevScreen = this.clickPrevScreen.bind(this);

    this.resetCssAnimation = this.resetCssAnimation.bind(this);

  }

  splitInto4s(props){

      let rows = [[]]
      let currentRow = 0;

      //console.log(this.props.testimonialData , props.testimonialData);

      let testimonialData = props.testimonialData

        testimonialData.data.map((item,index) => {

          rows[currentRow].push(item)
          if(index % 4 === 3){
            rows.push([])
            currentRow++
          }
          return null;



      })

      //console.log('Testimonal Rows',rows);

      this.setState({rows})
  }

  nextScreen(){

    let currentScreenIndex = (this.state.currentScreenIndex >= (this.state.rows.length-1))? 0 : this.state.currentScreenIndex + 1

        this.setState({currentScreenIndex})
  }

  clickNextScreen(){
    this.nextScreen();
    clearInterval(this.state.autoPlay)
  }

  prevScreen(){
    let currentScreenIndex = ((this.state.currentScreenIndex - 1 ) < 0)? this.state.rows.length-1 : this.state.currentScreenIndex - 1
        this.setState({currentScreenIndex})

  }

  clickPrevScreen(){
    this.prevScreen();
    clearInterval(this.state.autoPlay)
  }


  resetCssAnimation(){

        // HACK: To reset the css animation
        if(this.refs.container){
          setTimeout(() => {
            let testies = this.refs.container.querySelectorAll('.testimonial');

          //  console.log(this.refs.container.querySelectorAll('.testimonial'))
            for(let i = 0; i < testies.length; i++){

              ///console.log(testies[i].classList);

              testies[i].classList.add('fade-in')
            }
          },0)
        }
  }




  componentWillReceiveProps(newProps){

    if(newProps.testimonialData){
      this.splitInto4s(newProps);
      this.resetCssAnimation();
    }

  }

  componentDidMount(){
    let autoPlay = setInterval(this.nextScreen,5000)
    this.setState({autoPlay})
  }

  componentWillUnmount(){
    clearInterval(this.state.autoPlay)
  }


  componentDidUpdate(){
    //console.log("Testimonails did update");
    this.resetCssAnimation();
    (this.state.rows.length)?
      setTimeout(
      this.resetCssAnimation
      ,100)
    : null

  }


  render () {



    let testimonalClass =  'testimonial'



    return(
      <div className="testimonials" ref="container">
        <DataLoader load="testimonials">
            <div>
                {(this.state.rows.length)?

                    this.state.rows[this.state.currentScreenIndex].map((item,index) => {

                      return (<div className={testimonalClass+' id'+item.id} key={'t'+index}>
                                  <blockquote dangerouslySetInnerHTML={{__html:item.acf.testimonial}}></blockquote>
                                  <div className="name" dangerouslySetInnerHTML={{__html:item.title.rendered}}></div>
                              </div>)

                    })


                  : null

                }
              </div>

              <div>
              {



                <div className="controls">
                    <div className={(this.state.currentScreenIndex===0)? "prev hide" : "prev"} onClick={this.clickPrevScreen}>
                        <h5>Previous</h5>
                        <span>4 quotes</span>
                    </div>
                    <div className="indicator">
                      {this.state.currentScreenIndex + 1} of {this.state.rows.length}
                    </div>

                    <div className={(this.state.currentScreenIndex===this.state.rows.length-1)? "next hide" : "next"} onClick={this.clickNextScreen}>
                      <h5>Next</h5>
                      { (this.state.rows[this.state.currentScreenIndex+1])?
                        <span>{this.state.rows[this.state.currentScreenIndex+1].length} quotes</span>
                      : null }
                    </div>

                  </div>
              }
            </div><div>
              {
                this.resetCssAnimation()
              }
            </div>
        </DataLoader>
      </div>
    )
  }
}

const mapStateToProps = (state) =>{
  const testimonialData =  state.testimonialData

  return{
    testimonialData
  }
}

export default connect(mapStateToProps)(Testimonials);



// WEBPACK FOOTER //
// ./src/modules/testimonials/Testimonials.js